import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * SAMPLE COPY — the product has no buyers yet.
 * Replace every quote, name and photo with a real buyer review (with
 * permission) before running traffic. US FTC rules prohibit fabricated reviews.
 * Keep reviews free of student-outcome claims (no "my students made X% progress").
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      "I ran the Lost Backpack grid with a group of four and four different goals, all off one page. It's the first group this year I didn't plan the night before.",
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      "The Start level sold me. My kindergartners can't read yet, and with the picture strip they're in the same game as my fourth graders.",
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      "I'm split across two schools. With the rows already written, prep is picking a theme — not building a session from scratch.",
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'My /r/ student used to wait while I did WH-questions with everyone else. Now the Sound row keeps him practicing on every single turn.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'Black and white, print once, nothing to laminate. I use most of it straight from the screen.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      "I was worried it would be US-only. The terms table on page 2 and the neutral wording made it easy to use with my caseload here.",
    author: coaches[5].name,
    role: coaches[5].role,
    avatar: coaches[5].avatar,
  },
]
